const ProductVariants = document.querySelector('.js-product-variants');

if(ProductVariants) {
    ProductVariants.addEventListener('change', (e) => {
        window.location.href = e.target.value;
    })
}
